import api from "./axios"

// Updated function to add an announcement
export function addAnnouncement(datetime, header, message, committeeId, createdBy) {
    return api.post(`/announcements/`, {
        // Replace with actual parameters/data if needed
        time_to_send: datetime,
        header: header,        
        message: message,
        committee: committeeId,
        created_by: createdBy
    })
        .then(response => {
            //console.log("Created announcement:", response.data);
            return response.data;
        })
        .catch(error => {
            console.error("Error creating announcement:", error);
            throw error;
        });
}

// Helper function to get all available committees
export function getCommittees() {
    return api.get(`/committees/`)
        .then(response => {
            //console.log("Fetched committees:", response.data);
            return response.data;
        })
        .catch(error => {
            //console.error("Error fetching committees:", error);
            throw error;
        });
}

// Helper function to get committee from id
export function getCommitteeFromId(committeeId) {
    return api.get(`/committees/?id=${committeeId}`)
        .then(response => {
            return response.data[0];    // assuming there's always only one match
        })
        .catch(error => {
            console.error("Error fetching committee:", error);
            throw error;
        });
}


// Helper function to get committee members for a specific committee
export function getCommitteeMembers(committeeId) {
    return api.get(`/committees/memberships/?committee=${committeeId}`)
        .then(response => {
            //console.log("Fetched committee members:", response.data);
            return response.data;
        })
        .catch(error => {
            //console.error("Error fetching committee members:", error);
            throw error;
        });
}

// Helper function to get all committees for a CAPTain
// (array of committee objects)
export function getCommitteesByUser(userId) {
    return api.get(`/committees/memberships/?user=${userId}`)
        .then(response => {
            return Promise.all(response.data
                .map(x => getCommitteeFromId(x.committee)));
        })
        .catch(error => {
            console.error("Error fetching committee(s) id led by user:", error);
            throw error;
        })
}

// Helper function to get all committees where CAPTain is a leader of
// (array of committee objects)
export function getCommitteesLedByUser(userId) {
    return api.get(`/committees/memberships/leader/${userId}/`)
        .then(response => {
            return Promise.all(response.data
                .map(x => getCommitteeFromId(x.committee)));
        })
        .catch(error => {
            console.error("Error fetching committee(s) id led by user:", error);
            throw error;
        })
}

// Temp helper function to get id from name
// (used to identify user after successful login, but should be returned by /login and not using this)
export function getUserIdFromName(name) {
    return api.get(`/students/userid/${name}/`)
        .then(response => {
            //console.log("User id: ", response.data);
            return response.data;
        })
        .catch(error => {
            console.error("Error fetching user id:", error);
            throw error;
        });
}

export async function getAllAnnouncement() {
  return await api.get(`/announcements/`)
}

export async function getAnnouncementsByCommittee(committeeId) {
  const res = await api.get(`/announcements/?committee=${committeeId}`)
  return res;
}

export async function getAnnouncementsForCommittees(committees) {
  // committees: array of objects with committee_id, or array of ids
  const ids = committees.map(c => c.committee_id ?? c);

  const requests = ids.map(id =>
    api.get(`/announcements/`, { params: { committee: id } })
  );

  const responses = await Promise.all(requests);
  // flatten into single array
  return responses.flatMap(r => r.data);
}

export async function deleteAnnouncement(announcementId) {
  await api.delete(`/announcements/${announcementId}/`);
}